export enum taskKind {
    EXPORT_KIND = 0,
    BATCH_KIND = 100,
}
